import { Search } from 'react-router-dom'

export const getUrlSearchParam = (searchObj: Search, param: string): string | null => {
	const urlParams = new URLSearchParams(searchObj)
	return urlParams.get(param)
}
